<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :span="10">
            <a-form-item :label="'日期'" :labelCol="{ span: 6 }" :wrapperCol="{ span: 14, offset: 1 }">
              <!-- <a-date-picker v-model="queryParam.date" format="YYYY-MM-DD" /> -->
              <el-date-picker v-model="queryParam.date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </a-form-item>
          </a-col>
          <a-col :span="14">
            <a-button style="margin-left: 20px" type="primary" @click="getTableData()">查询</a-button>
            <a-button style="margin-left: 20px" type="primary" @click="getTableData('reset')">重置</a-button>
            <a-upload
              ref="upload"
              name="file"
              :multiple="false"
              :action="'/api/web/webpublic/statistics/insertAdTrafficList'"
              :headers="getHeaders()"
              :data="uploadDataParam"
              :openFileDialogOnClick="openFileDialogOnClick"
              @change="handleChangeUpload"
            >
              <a-button
                type="primary"
                @click="openFileDialogOnClick = true"
                style="margin-left: 10px"
                :loading="uploadLoading"
              >
                上传文件
              </a-button>
            </a-upload>
          </a-col>
        </a-row>
      </a-form>
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        stripe
        v-loading="loading"
        :header-cell-style="{ fontSize: '14px', backgroundColor: '#f8f8f8', color: '#333' }"
      >
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-table
              :data="scope.row.children"
              style="width: 100%"
              border
              :header-cell-style="{ fontSize: '14px', backgroundColor: '#f8f8f8' }"
            >
              <el-table-column
                v-for="(item, index) in childColumns"
                :key="index"
                :label="item.title"
                :prop="item.dataIndex"
              >
                <template></template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>

        <el-table-column v-for="(item, index) in columns" :key="index" :label="item.title" :prop="item.dataIndex">
          <template></template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 20px;display: flex;justify-content: end;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageConfig.pageNum"
        :page-sizes="[10, 30, 60, 100]"
        :page-size="pageConfig.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="pageConfig.total"
      >
      </el-pagination>
    </div>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { queryAdTrafficList, insertAdTrafficList } from '@/webpublicapi/adTrafficList'
import { getHeaders } from '@/utils/request'

import moment from 'moment'

export default {
  name: 'AppList',
  components: {},
  data() {
    return {
      pageConfig: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      uploadLoading: false,
      fileList: [],
      uploadDataParam: {},
      openFileDialogOnClick: false,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        date: moment()
          .add(0, 'days')
          .format('YYYY-MM-DD') //默认当天
      },
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },

      tableData: [],
      childTableData: [],
      loading: false,

      columns: [
        {
          title: '国家',
          align: 'left',
          dataIndex: 'country',
          key: 'country'
        },
        {
          title: '应用名称',
          align: 'left',
          dataIndex: 'appName',
          key: 'appName'
        },
        {
          title: '日期',
          align: 'left',
          dataIndex: 'date',
          key: 'date'
        },

        {
          title: '金额花费',
          align: 'left',
          dataIndex: 'spendAmount',
          key: 'spendAmount'
        },
        {
          title: '安装',
          align: 'left',
          dataIndex: 'installs',
          key: 'installs'
        },
        {
          title: '安装成本',
          align: 'left',
          dataIndex: 'installCost',
          key: 'installCost'
        },
        {
          title: '注册户',
          align: 'left',
          dataIndex: 'registeredUsers',
          key: 'registeredUsers'
        },
        {
          title: '申贷户',
          align: 'left',
          dataIndex: 'loanApplicants',
          key: 'loanApplicants'
        },
        {
          title: '申贷成本',
          align: 'left',
          dataIndex: 'loanApplicationCost',
          key: 'loanApplicationCost'
        },
        {
          title: '申贷放款率',
          align: 'left',
          dataIndex: 'loanApprovalRate',
          key: 'loanApprovalRate'
        },
        {
          title: '新户｜均额',
          align: 'left',
          dataIndex: 'newCustomerAverage',
          key: 'newCustomerAverage'
        },
        {
          title: '展示CTR',
          align: 'left',
          dataIndex: 'displayCTR',
          key: 'displayCTR'
        },
        {
          title: '点击率CTR',
          align: 'left',
          dataIndex: 'clickThroughRateCTR',
          key: 'clickThroughRateCTR'
        },
        {
          title: '总数',
          align: 'left',
          dataIndex: 'totalCount',
          key: 'totalCount'
        },
        {
          title: '新户成本',
          align: 'left',
          dataIndex: 'newCustomerCost',
          key: 'newCustomerCost'
        }
      ],
      childColumns: [
        {
          title: '代理商',
          align: 'left',
          dataIndex: 'proxy',
          key: 'proxy'
        },
        {
          title: '渠道',
          align: 'left',
          dataIndex: 'channel',
          key: 'channel'
        },
        {
          title: '投放点位',
          align: 'left',
          dataIndex: 'placement',
          key: 'placement'
        },
        {
          title: '金额花费',
          align: 'left',
          dataIndex: 'spendAmount',
          key: 'spendAmount'
        },
        {
          title: '安装',
          align: 'left',
          dataIndex: 'installs',
          key: 'installs'
        },
        {
          title: '安装成本',
          align: 'left',
          dataIndex: 'installCost',
          key: 'installCost'
        },
        {
          title: '注册户',
          align: 'left',
          dataIndex: 'registeredUsers',
          key: 'registeredUsers'
        },
        {
          title: '申贷户',
          align: 'left',
          dataIndex: 'loanApplicants',
          key: 'loanApplicants'
        },
        {
          title: '申贷成本',
          align: 'left',
          dataIndex: 'loanApplicationCost',
          key: 'loanApplicationCost'
        },
        {
          title: '申贷放款率',
          align: 'left',
          dataIndex: 'loanApprovalRate',
          key: 'loanApprovalRate'
        },
        {
          title: '新户｜均额',
          align: 'left',
          dataIndex: 'newCustomerAverage',
          key: 'newCustomerAverage'
        },
        {
          title: '展示CTR',
          align: 'left',
          dataIndex: 'displayCTR',
          key: 'displayCTR'
        },
        {
          title: '点击率CTR',
          align: 'left',
          dataIndex: 'clickThroughRateCTR',
          key: 'clickThroughRateCTR'
        },
        {
          title: '总数',
          align: 'left',
          dataIndex: 'totalCount',
          key: 'totalCount'
        },
        {
          title: '新户成本',
          align: 'left',
          dataIndex: 'newCustomerCost',
          key: 'newCustomerCost'
        }
      ],
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  created() {
    this.getTableData()
  },
  methods: {
    getHeaders() {
      return getHeaders()
    },
    getTableData(type = 'normal') {
      if (type == 'reset') {
        this.queryParam.date = moment()
          .add(0, 'days')
          .format('YYYY-MM-DD')
      }
      this.loading = true
      this.queryParam.pageNum = this.pageConfig.pageNum
      this.queryParam.pageSize = this.pageConfig.pageSize
      queryAdTrafficList(this.queryParam).then(res => {
        this.pageConfig.total = res.data.total
        let data = res.data.rows

        this.tableData = data
        this.loading = false
      })
    },
    handleSizeChange(size) {
      this.pageConfig.pageSize = size
      this.getTableData()
    },
    handleCurrentChange(page) {
      this.pageConfig.pageNum = page
      this.getTableData()
    },
    handleChangeUpload(info) {
      if (info.file.status === 'done') {
        if (info.file.response.code === 1000) {
          this.$message.success(`${info.file.name} file uploaded successfully`)
          this.getTableData('reset')

          this.$refs.upload.sFileList = []
        } else {
          alert(info.file.response.msg)
        }
      } else if (info.file.status === 'error') {
        this.uploadLoading = false
        alert('system error!')
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import '~@/assets/less/common.less';
</style>
